/* eslint-disable no-unused-vars */

import React, { useContext, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  TextaccessorKey,
} from '@mui/material';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { LoadGif } from '../LoadGif';
import {
  DeleteDynamic,
  GetDynamic,
  GetProcesso,
  isValid,
} from 'src/services/auth';
import CustomInput, { MaskInput, SelectInput } from '../customInput';

import { ReactComponent as Reload } from 'src/assets/icons/reload.svg';
import { ReactComponent as Add } from 'src/assets/icons/oldPortal/adicionar.svg';
import { ReactComponent as End } from 'src/assets/icons/end.svg';
import { ReactComponent as SearchIcon } from 'src/assets/icons/searchFolder.svg';

import { ReactComponent as Trash } from 'src/assets/icons/trash.svg';
import { ReactComponent as Edit } from 'src/assets/icons/edit.svg';
import { Opacity } from '@mui/icons-material';

const columns = [
  {
    header: 'Id',
    accessorKey: 'id',
  },
  {
    header: 'Identificador',
    accessorKey: 'identificador',
  },

  {
    header: 'Empresa',
    accessorKey: 'nome',
  },

  {
    header: 'Cnpj',
    accessorKey: 'cnpj',
    Cell: ({ cell }) => {
      const raw = cell.getValue() || '';
      const cleaned = raw.replace(/\D/g, '').padStart(14, '0');
      const masked = cleaned.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5'
      );
      return masked;
    },
  },

  {
    header: 'Situação',
    accessorKey: 'situacao',
  },
];

export default function Emp({ Disabled }) {
  const [load, setLoad] = useState(false);
  const [showPopup, setShowPopup] = useState('');

  const [empData, setEmpData] = useState([]);
  const [empFilter, setEmpFilter] = useState([]);

  const [validate, setValidate] = useState([]);

  const [selectedRow, setSelectedRow] = useState({});

  const [newEmp, setNewEmp] = useState({});
  const [clearEmp, setClearEmp] = useState({
    nome: '',
    cnpj: '',
    situacao: '',
    url: '',
    identificador: '',
  });

  function handleAdd() {
    const emptyParams = Object.entries(newEmp)
      .filter(([key, value]) => value.trim() === '')
      .map(([key]) => key);

    if (emptyParams.length > 0) {
      setValidate(emptyParams);
      return;
    }

    const data = {
      nome: newEmp.nome,
      cnpj: newEmp.cnpj,
      identificador: newEmp.identificador,
      url: newEmp.url,
      situacao: newEmp.situacao,
    };

    GetDynamic('post', 'empresas', data)
      .then((res) => {
        setShowPopup('');
        handleConsulta();
      })
      .catch((error) => console.log(error));
  }

  function handleEdit() {
    const emptyParams = Object.keys(clearEmp).filter(
      (key) => !newEmp[key] || newEmp[key].trim() === ''
    );

    if (emptyParams.length > 0) {
      setValidate(emptyParams);
      return;
    }

    const data = {
      nome: newEmp.nome,
      cnpj: newEmp.cnpj,
      identificador: newEmp.identificador,
      url: newEmp.url,
      situacao: newEmp.situacao,
    };

    GetDynamic('PUT', `empresas/${selectedRow.id}`, data)
      .then((res) => {
        setShowPopup('');
        handleConsulta();
      })
      .catch((error) => console.log(error));
  }

  function handleDelete() {
    DeleteDynamic(`empresas/${selectedRow.id}`)
      .then((res) => {
        setShowPopup('');
        handleConsulta();
      })
      .catch((error) => console.log(error));
  }

  function timedLoad(time) {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, time);
  }

  function handleConsulta() {
    setShowPopup('');
    setLoad(true);

    GetDynamic('get', 'empresas')
      .then((response) => {
        timedLoad(1000);
        setEmpData(response);
      })
      .catch(() => {
        timedLoad(1000);
      });
  }

  const isMobile = window.innerWidth <= 768;
  const emp = useMaterialReactTable({
    columns,
    data: empData,

    paginationDisplayMode: 'pages',
    enablePagination: 'true',
    enableRowActions: 'true',
    enableStickyHeader: true,
    enableStickyFooter: true,
    rowPinningDisplayMode: 'top-and-bottom',
    enableFullScreenToggle: false,

    muiToolbarAlertBannerProps: {
      sx: {
        backgroundColor: 'transparent',
        color: '#146b7c',
      },
    },

    initialState: {
      showGlobalFilter: true,
      density: 'compact',
      columnPinning: !isMobile
        ? { left: ['mrt-row-select', 'mrt-row-actions'] }
        : {},
      pagination: { pageSize: 15 },
    },

    muiTopToolbarProps: {
      className: 'myTable-toolbar',
    },

    muiTableContainerProps: {
      sx: {
        flex: 1,
        height: '100%',
        maxHeight: 'calc(100% - 6.5rem)',
        overflow: 'auto',
      },
    },

    muiTablePaperProps: {
      sx: {
        boxShadow: 'none',
      },
    },

    muiPaginationProps: {
      color: 'primary',
      shape: 'rounded',
      showRowsPerPage: true,
      variant: 'outlined',
    },

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Deletar">
          <IconButton
            onClick={() => {
              setShowPopup('delete');
              setSelectedRow(row.original);
            }}
          >
            <Trash className="tableIcon line" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Editar">
          <IconButton
            onClick={() => {
              setShowPopup('edit');
              setSelectedRow(row.original);
              setValidate([]);
              setNewEmp({
                nome: row.original.nome,
                cnpj: row.original.cnpj,
                situacao: row.original.situacao,
                url: row.original.url,
                identificador: row.original.identificador,
              });
            }}
          >
            <Edit className="tableIcon line" />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    localization: MRT_Localization_PT_BR,
  });

  /*useEffect(() => {
    handleConsulta();
  }, []);*/

  return (
    <div className={`Emp ${Disabled && 'hide'}`}>
      {load && <LoadGif />}

      {showPopup === 'add' && (
        <div className="modal absoluteCenter add">
          <h2> Adicionar Empresa </h2>

          <div className="inputs">
            <CustomInput
              Class={`${validate.includes('nome') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewEmp((prev) => ({ ...prev, nome: e.target.value }))
              }
              Type="text"
              PlaceHolder="Nome *"
            />

            <MaskInput
              Class={`${validate.includes('cnpj') ? 'mark ' : ''}`}
              OnChange={(e) => {
                const rawValue = e?.target?.value?.replace(/\D/g, '') || '';
                setNewEmp((prev) => ({ ...prev, cnpj: rawValue }));
              }}
              Type="text"
              PlaceHolder="Cnpj *"
              Mask="99.999.999/9999-99"
            />

            <SelectInput
              Class={`${validate.includes('situacao') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewEmp((prev) => ({ ...prev, situacao: e.target.value }))
              }
              Options={{ S: 'Sim', N: 'Não' }}
              PlaceHolder="Situação *"
            />

            <CustomInput
              Class={`${validate.includes('url') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewEmp((prev) => ({ ...prev, url: e.target.value }))
              }
              Type="text"
              PlaceHolder="Url *"
            />

            <CustomInput
              Class={`${validate.includes('identificador') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewEmp((prev) => ({
                  ...prev,
                  identificador: e.target.value,
                }))
              }
              Type="text"
              PlaceHolder="Identificador *"
            />

            <input style={{ opacity: 0 }} />

            {isValid(validate) && (
              <span className="error">
                * Items obrigatórios não preenchidos
              </span>
            )}
          </div>

          <div className="controls">
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              <End />
              Cancelar
            </button>
            <button
              onClick={() => {
                handleAdd();
              }}
              className="mainButton turquoise"
            >
              <Add />
              Adicionar
            </button>
          </div>
        </div>
      )}

      {showPopup === 'delete' && (
        <div className="modal absoluteCenter delete">
          <h3>Deletar: </h3>
          <h4>
            {selectedRow.id} | {selectedRow.nome}
          </h4>
          <div className="controls">
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              <End />
              Cancelar
            </button>
            <button onClick={() => handleDelete()} className="mainButton red">
              <Trash />
              Confirmar
            </button>
          </div>
        </div>
      )}

      {showPopup === 'edit' && (
        <div className="modal absoluteCenter edit">
          <h2>Editar {selectedRow.NOME}</h2>

          <div className="inputs">
            <CustomInput
              Class={`${validate.includes('nome') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewEmp((prev) => ({ ...prev, nome: e.target.value }))
              }
              Type="text"
              PlaceHolder="Nome *"
              DefaultValue={newEmp.nome}
            />

            <MaskInput
              Class={`${validate.includes('cnpj') ? 'mark ' : ''}`}
              OnChange={(e) => {
                const rawValue = e?.target?.value?.replace(/\D/g, '') || '';
                setNewEmp((prev) => ({ ...prev, cnpj: rawValue }));
              }}
              Type="text"
              PlaceHolder="Cnpj *"
              Mask="99.999.999/9999-99"
              DefaultValue={newEmp.cnpj}
            />

            <SelectInput
              Class={`${validate.includes('situacao') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewEmp((prev) => ({ ...prev, situacao: e.target.value }))
              }
              Options={{ A: 'Sim', N: 'Não' }}
              PlaceHolder="Situação *"
              DefaultValue={newEmp.situacao}
            />

            <CustomInput
              Class={`${validate.includes('url') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewEmp((prev) => ({ ...prev, url: e.target.value }))
              }
              Type="text"
              PlaceHolder="Url *"
              DefaultValue={newEmp.url}
            />

            <CustomInput
              Class={`${validate.includes('identificador') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewEmp((prev) => ({
                  ...prev,
                  identificador: e.target.value,
                }))
              }
              Type="text"
              PlaceHolder="Identificador *"
              DefaultValue={newEmp.identificador}
            />

            <input style={{ opacity: 0 }} />

            {isValid(validate) && (
              <span className="error">
                * Items obrigatórios não preenchidos
              </span>
            )}
          </div>

          <div className="controls">
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              <End />
              Cancelar
            </button>
            <button onClick={() => handleEdit()} className="mainButton yellow">
              <Edit />
              Salvar
            </button>
          </div>
        </div>
      )}

      <div className="controls">
        <button
          onClick={() => {
            setValidate([]);
            setShowPopup('add');
            setNewEmp(clearEmp);
          }}
          className="mainButton turquoise"
        >
          <Add />
          Adicionar
        </button>
        <button onClick={() => handleConsulta()} className="mainButton yellow">
          <SearchIcon />
          Consultar
        </button>
        <button
          onClick={() => handleConsulta()}
          className={`mainButton turquoise reload ${load && ' loading'}`}
        >
          <Reload />
        </button>
      </div>
      <div className="tableWrapper">
        {(load || showPopup !== '') && (
          <button onClick={() => setShowPopup('')} className="fade" />
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
            borderRadius: '0.5rem',
            overflow: 'hidden',
          }}
        >
          <MaterialReactTable table={emp} />
        </Box>
      </div>
    </div>
  );
}

Emp.propTypes = {
  Disabled: PropTypes.bool,
};
